import {
    Box
} from '@mui/material';
import { TreeItem } from '@mui/x-tree-view/TreeItem';

import HasPermission from '../../contexts/PermissionContext';
import WhiteTreeItem from '../SideItems/WhiteTreeItem'
import { useMemo } from 'react';

export default function SettingsSidebarComponent(props) {

    const { data, label, dotNotatedKey } = props
    const isObject = (x) => Object.prototype.toString.call(x) === "[object Object]" && x != null;
    const isTable = (key, x) => label[key] && label[key].hasOwnProperty('type') && label[key]['type'] === 'table'

    // Function to escape all periods and whitespaces
    function escapeChars(value){
        return value.replace(/[.\s]/g, '\\$&')
    }

    const itemClick = (fullKey) => {
        const querySelectorString = `#Settings\\.${escapeChars(fullKey)}`
        // Query the DOM for the node with the defined ID
        const elem = document.querySelector(querySelectorString)
        // Scroll to that element in the viewport
        elem.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    return useMemo(() => (
        <Box>
            {Object.entries(data).map(([k, v], index) => {
                // DotNotatedKey flattens the nested dictionary object into a dotnotated string
                // If the component is being initialized with the dotNotatedKey prop
                // we assume that it was called recursively when generating
                // intermediate tree nodes
                const fullKey = dotNotatedKey  ? `${dotNotatedKey}.${k}` : k
                return (
                    label[fullKey] && label[fullKey].hasOwnProperty("hidden") && label[fullKey]['hidden'] === true 
                ?
                    <div key={index}></div>
                :
                <Box
                    my={1}
                    key={fullKey}
                >
                    <HasPermission permission={label[fullKey]?.permissions ?? ""}>
                    {
                        // Check if the current key is a leaf or intermediate key
                        isObject(v) && !isTable(fullKey, v)
                        ?
                        // If intermediate node, call this component with the value of the key
                        // to process the nested values
                        (
                            <WhiteTreeItem 
                                nodeId={fullKey}
                                label={label[fullKey]?.label || k}
                                // onClick={(e) => itemClick(e, fullKey)}
                            >
                                <SettingsSidebarComponent
                                    data={v}
                                    label={label}
                                    dotNotatedKey={fullKey}
                                />
                            </WhiteTreeItem>
                        )
                        :
                        // Leaf node
                        (
                            <WhiteTreeItem
                                nodeId={fullKey}
                                label={label[fullKey]?.label || k}
                                onClick={() => itemClick(fullKey)}
                            />
                        )
                    }
                    </HasPermission>
                </Box>
              )}
            )}
        </Box>
    ), [data])
}